<ng-container *ngIf="passportForm" [formGroup]="passportForm">
  <div class="f-flyer-form-inputs">
    <app-form-text-input
      [form]="passportForm"
      [formControlSelector]="passportNumberSelector"
      [id]="passportNumberSelector"
      [maxLength]="20"
      [isSubmitted]="isSubmitted"
      [formInputType]="documentInputType"
      [placeholder]="'BOOKING_MODULE.PAX.PASSPORT.LABEL' | transloco">
    </app-form-text-input>
  </div>
  <div class="button-form-row">
    <div class="button-container">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.PAX.PASSPORT.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </div>
  </div>
</ng-container>
